import {
  FormFieldWidget,
  FormO2MTableFieldWidget,
  ModelFieldType,
  SPI,
  SubmitRelationValue,
  SubmitValue,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { RuntimeO2MField } from '@kunlun/dependencies';
import StarRuleTable from './StarRuleTable.vue';

/**
 * 编辑评估规则 - 星级规则配置自定义 Widget
 *
 * <p>渲染动态行星级规则表格（创建页默认 1 行 1 星，可新增/删除，星级为数字输入 + “星”后缀，不固定档数）：
 * 每行含星级、分数区间（minScore/maxScore）、描述、操作栏。</p>
 *
 * <p>绑定字段：DeliAriesPlatformEvaluationRule.starRules（OneToMany）。
 * 复用默认 O2M widget 名 'Table' + 字段名 'starRules' 精确覆盖，无需改设计器。
 * 同时注册 Detail 视图：详情页复用编辑布局但全表只读。
 * 注意：starRules 由父模型继承而来，运行时字段归属可能是父模型，故不约束 model，仅按 name 匹配（与 OrderPlanProductDetail 一致）。</p>
 */
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Detail],
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'starRules',
    multi: true
  })
)
export class FormStarRuleTableFieldWidget extends FormO2MTableFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(StarRuleTable);
    return this;
  }

  @Widget.Reactive()
  public get _field(): RuntimeO2MField {
    return this.field as RuntimeO2MField;
  }

  /** 详情视图下只读（作为 prop 传给组件，与 _field 同机制） */
  @Widget.Reactive()
  public get isReadonly(): boolean {
    return this.getUrlParameters().viewType === ViewType.Detail;
  }

  /**
   * 直接以 { 字段名: 行数组 } 提交，绕开基类的 O2M 序列化，
   * 避免 starLevel/minScore/maxScore/description 被子视图字段元数据过滤掉。
   */
  public async submit(submitValue: SubmitValue): Promise<SubmitRelationValue | Record<string, unknown> | undefined> {
    return { [this.itemName]: this.value || [] };
  }
}
